// extracted by mini-css-extract-plugin
export var image1 = "styles-module--image1--9e131";
export var image2 = "styles-module--image2--3dbef";
export var image3 = "styles-module--image3--db591";
export var image4 = "styles-module--image4--e0624";
export var image5 = "styles-module--image5--6fd2c";
export var image6 = "styles-module--image6--86f16";
export var imageGalleryWrapper = "styles-module--imageGalleryWrapper--d0ded";